// extracted by mini-css-extract-plugin
export var fileExt = "_u3-8";
export var fileIcon = "_u3-6";
export var fileLink = "_u3-5";
export var fileName = "_u3-7";
export var image = "_u3-1";
export var imageError = "_u3-3";
export var imageErrorIcon = "_u3-4";
export var imageLink = "_u3-0";
export var imageLoaded = "_u3-2";